export const getSubmitData = (values = {}) => {
  const res = {};

  res.label = values.label;
  res.warehouse = values.warehouse?.id ?? values.warehouse;
  res.alerts = values.alerts;

  res.devicesGroup = (values.devicesGroup || []).map(dg => {
    const deviceGroupWithoutAlerts = {
      label: dg.groupName || '',
      devices: dg.devices?.map(obj => obj.id) || []
    };

    const alerts = (dg.devices || []).reduce((acc, d) => (d.alertOn ? [...acc, d.id] : acc), []);
    const deviceGroupForSubmit = dg.projectAlertId ?
      {
        ...deviceGroupWithoutAlerts,
        projectAlertId: dg.projectAlertId,
        alerts: alerts.length ? alerts : undefined
      } : deviceGroupWithoutAlerts;

    if (typeof dg.id === 'number') {
      return { id: dg.id, ...deviceGroupForSubmit };
    }
    return deviceGroupForSubmit;
  });

  return res;
};

export const validDataForSelect = (d = []) => {
  if (Array.isArray(d)) {
    return d.map(item => {
      if (!item) return item;

      const base = item.data || item;
      return {
        ...base,
        label: base.label,
        value: base.id
      };
    });
  }

  return d;
};

export const getAllApplianceDevices = (formData = []) => {
  if (!formData.length) return formData;

  const data = formData.reduce((acc, curr) => {
    const applianceDevices = curr.devices;
    if (applianceDevices) {
      acc.push(...applianceDevices);
    }

    return acc;
  }, []);

  return data;
};
